export const resetScroll = () => window.scrollTo(0, 0);
